
import React from 'react';
import { Button } from '@/components/ui/button';

interface CalculatorButtonProps {
  value: string;
  onClick: () => void;
  variant?: 'number' | 'operation' | 'control' | 'wide';
}

const CalculatorButton: React.FC<CalculatorButtonProps> = ({ value, onClick, variant = 'number' }) => {
  let className = "font-mono font-bold border-2 border-gray-800";
  
  switch(variant) {
    case 'number':
      className += " bg-gray-500 text-white hover:bg-gray-600";
      break;
    case 'operation':
      className += " bg-amber-600 text-white hover:bg-amber-700";
      break;
    case 'control':
      className += " bg-red-700 text-white hover:bg-red-800";
      break;
    case 'wide':
      className += " bg-gray-500 text-white hover:bg-gray-600 col-span-2";
      break;
  }

  return (
    <Button variant="outline" className={className} onClick={onClick}>
      {value}
    </Button>
  );
};

export default CalculatorButton;
